import { useContext, useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { ApiContext } from '../App';
import { UserContext } from '../App';
import { EntitiesContext } from '../App';
import * as ActionTypes from '../constants/action-types';

const options = {}
const resource = 'inventory';

export const useCreateInventory = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);
  const sale = entities.state.get('sale').find(s => s.open);

  return useMutation(inventory => api.post(`/${resource}`, inventory.set('sale_id', sale.id)), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITY,
      payload: data.data
    })
  });
}

export const useUpdateInventory = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(inventory => api.put(`/${resource}/${inventory.id}`, inventory), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITY,
      payload: data.data
    })
  });
}

export const useDeleteInventory = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(inventory => api.delete(`/${resource}/${inventory.id}`), {
    onMutate: item => entities.dispatch({
      type: ActionTypes.CLEAR_ENTITY,
      payload: {
        type: resource,
        id: item.id
      }
    })
  })
}

export const useGetInventory = () => {
  const api = useContext(ApiContext);
  const user = useContext(UserContext);
  const entities = useContext(EntitiesContext);

  const inventory = useQuery(resource, () => api.get(`/accounts/${user.user.id}/${resource}`), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITIES,
      payload: data.data
    })
  });

  return inventory;
}

export const useAdminGetInventory = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(id => api.get(`/accounts/${id}/${resource}`), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITIES,
      payload: data.data
    })
  })
}

export const useFindInventory = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(id => api.get(`/${resource}/${id}`), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITY,
      payload: data.data
    }),
    onError: () => entities.dispatch({
      type: ActionTypes.CLEAR_ENTITIES,
      payload: 'inventory'
    })
  });
}

export const usePrintInventory = () => {
  const api = useContext(ApiContext);

  return useMutation(() => api.post(`/${resource}/print`));
}
